<template>
  <div class="o-the-alerts">
    <MoleculeTheAlerts/>
  </div>
</template>

<script>
export default {
  name: 'OrganismTheAlerts',

  components: {
    MoleculeTheAlerts: () => import('@/components/molecules/MoleculeTheAlerts')
  }
}
</script>
